import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { contactApi } from "../api/contactApi";

export const useContacts = (params) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["contacts", params],
    queryFn: async () => await contactApi.getAll(params),
    keepPreviousData: true,
  });

  return {
    data: data?.data || [],
    pagination: data?.pagination || {
      page: 1,
      limit: 10,
      total: 0,
      totalPages: 1,
    },
    isLoading,
    error,
    refetch,
  };
};

export const useContact = (id) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["contact", id],
    queryFn: async () => await contactApi.getById(id),
    enabled: !!id,
  });

  return {
    data: data || null,
    isLoading,
    error,
  };
};

export const useContactActions = () => {
  const queryClient = useQueryClient();

  const updateContactStatus = useMutation({
    mutationFn: async ({ id, data }) => await contactApi.updateStatus(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contacts"] });
    },
  });

  const deleteContact = useMutation({
    mutationFn: async (id) => await contactApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contacts"] });
    },
  });

  return {
    updateContactStatus,
    deleteContact,
  };
};
